GP.views.ContentCounts = Backbone.Marionette.ItemView.extend({
    template: function(serialized_data) {
        return template('content-counts', serialized_data);
    },
    initialize:function(opts) {
        // Render when adding comments so template helpers fire.
        this.listenTo(this.model.get('comments'), 'add', this.render);
    },    
    templateHelpers: {
        self_view: function() {
            return this.content.duid === GP.sdata.my_user.duid;
        },
        like_header: function() {
            return (this.content.like_count > 0);
        },
        like_text_plural: function() {
            return (this.content.like_count > 1);
        },
        comment_text_plural: function() {
            return (this.content.comment_count > 1);
        },
        show_comment_link: function() {
            if (!this.content.from_ajax && GP.sdata.my_user.gender == 'MAN' && this.content.duid != GP.sdata.my_user.duid && this.content.comment_count > 0) {
                return true;
            }
            // Hide 'view more' link if showing all comments.
            if (this.content.comments.length >= this.content.comment_count) {
                return false;
            }

            // Show view more link if more than 10 comments on own profile, 5 otherwise.
            return ((this.content.duid == GP.sdata.my_user.duid && this.content.comment_count > 10) || this.content.comment_count > 5);
        },
        comment_count_header: function() {
            return (this.content.comment_count > 0 && !_bank_site);
        },
        show_timeago: function() {
            // show timestamp on profile if content is less
            // than 2 years old or if it's your own profile.
            if (!_bank_site && (typeof profile_view != 'undefined' && profile_view && typeof self_profile_view !== 'undefined' && !self_profile_view)) {
                var _content_time  = Math.abs(new Date() - new Date(this.content.ctime)) / 1000 / 60 / 60;
                var max_display_time = 8760 * 2;

                return (_content_time < max_display_time);
            } else {
                return !_bank_site;
            }
        }
    },
    serializeData: function() {
        // overwritten function for passing custom data to handlebars template
        var data = {};
        data = {
            content: this.model.toJSON()
        };

        data.content.like_count = parseInt(data.content.like_count,10);
        data.content.like_count_k = GP.Util.k_formatter(data.content.like_count);
        data.content.comment_count = parseInt(data.content.comment_count,10);
        data.content.comment_count_k = GP.Util.k_formatter(data.content.comment_count);
        return data;
    },
    modelEvents: {
        'change:like_count': 'render',
        'change:comment_count': 'render',
    },
    className: 'counts-wrap',
    onRender: function() {
        // Format and display timestamp
        jQuery.timeago.settings.strings = GP.Util.configs.timeago;
        this.$el.find('.timeago').timeago();

    }
});
